import React from "react";

const SummerSchoolResearchContext = React.createContext();

export { SummerSchoolResearchContext };
